// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__A8+CK","frontEnd":"Skills_frontEnd__jAeHK","skillsList":"Skills_skillsList__1syu1"};